import { useOutlet } from '@/util/react-router-dom';
import { Header } from './header/header';
import { Footer } from './footer/footer';
import styles from './layout.module.css';
import { HeaderVisitNavigation } from './navigation/header-visit-navigation';
import { ReactNode } from 'react';

interface LayoutProps {
  simplified?: boolean;
  forVisit?: boolean;
  hideVisitButton?: boolean;
  children?: ReactNode;
}

export function Layout({
  simplified = false,
  forVisit = false,
  hideVisitButton,
  children,
}: LayoutProps) {
  const outlet = useOutlet();

  return (
    <div className={styles.layout}>
      <Header simplified={simplified} hideVisitButton={hideVisitButton} />
      {forVisit && <HeaderVisitNavigation />}
      <main className={styles.mainContent}>{outlet ?? children}</main>
      <Footer />
    </div>
  );
}
